import React from 'react';
import { Form, Switch } from 'antd';
import { useHistory } from 'react-router-dom';

import Title from 'components/components/TitleWithActions/components/Title';
import DrawerButton from 'components/components/Drawer/components/DrawerButton';
import { FormBuilder } from 'components/components';
import { scrollToFirstError } from 'components/components/FormBuilder/utils/helpers';
import {
  StartupNamesList,
  ventureBuilderCreateFields,
} from 'components/VentureBuilderForms';
import { useCreateVentureBuilder } from 'packages/venture_builder_repository';
import { composeVentureBuilderDetailsUrl } from 'routes/routeComposers';
import showNotification from 'services/utils/showNotification';
import { AddVentureBuilderDrawerProps, AddVentureBuilderFormValues } from 'types/ventureBuilders';

import './AddVentureBuilderDrawer.scss';

const initialValues: Partial<AddVentureBuilderFormValues> = {
  startups: [{ name: '', email: '' }],
  active: true,
};

const AddVentureBuilderDrawer = ({
  actions: { setIsDrawerOpen },
}: AddVentureBuilderDrawerProps) => {
  const [form] = Form.useForm<AddVentureBuilderFormValues>();
  const history = useHistory();
  const { mutate, isPending } = useCreateVentureBuilder();

  const clearServerEmailError = (changed: { email?: string }) => {
    if (changed.email !== undefined) {
      form.setFields([{ name: 'email', errors: [] }]);
    }
  };

  const handleSubmit = (values: AddVentureBuilderFormValues) => {
    mutate(values, {
      onSuccess: ({ ventureBuilderId, startupIds }) => {
        showNotification(`Venture Builder has been created with ${startupIds.length} startup(s)`);
        setIsDrawerOpen({ isDrawerOpen: false });
        history.push(composeVentureBuilderDetailsUrl(ventureBuilderId));
      },
      onError: (error) => {
        showNotification(error.message, true, 400);
        if (/email/i.test(error.message) && !/startup/i.test(error.message)) {
          form.setFields([{ name: 'email', errors: [error.message] }]);
        }
      },
    });
  };

  return (
    <Form
      className="add-venture-builder-drawer form-standalone"
      form={form}
      initialValues={initialValues}
      onFinish={handleSubmit}
      onFinishFailed={scrollToFirstError}
      validateTrigger="onChange"
      onValuesChange={clearServerEmailError}
    >
      <Title title="Venture Builder Details" size="m" />
      <FormBuilder oneColumn formFragment fields={ventureBuilderCreateFields} />

      <Title title="Startups" size="s" />
      <StartupNamesList name="startups" />

      <div className="add-venture-builder-drawer__switches">
        <Form.Item name="active" label="Active account" valuePropName="checked" colon={false}>
          <Switch />
        </Form.Item>
      </div>

      <DrawerButton isLoading={isPending}>Add Venture Builder</DrawerButton>
    </Form>
  );
};

export default AddVentureBuilderDrawer;
